// Generic utility for creating store updater functions
export function createUpdater() {
    return (key) => {
        return (set) => {
            // Use generic value type V instead of the possibly literal-typed S[K]
            return (value) => {
                return set((state) => ({
                    [key]: typeof value === "function"
                        ? value(state[key])
                        : value,
                }));
            };
        };
    };
}
